import { useTranslation } from 'react-i18next';

import { getValidatedFormats } from '@entities/attachment/lib';
import { getNameExtension } from '@shared/helpers';

import { isNotValidateSize } from '../isNotValidateSize';

enum Errors {
    // @ts-ignore
    FORMAT = i18next.t('Tasks.ModalFileUploader.useUploadFile.FormatError.text'),
    // @ts-ignore
    SIZE = i18next.t('Tasks.ModalFileUploader.useUploadFile.SizeError.text'),
    // @ts-ignore
    COUNT = i18next.t('Tasks.ModalFileUploader.useUploadFile.CountError.text'),
}

export const useUploadFiles = (
    onAddFile: (files: File[]) => void,
    alreadyAttachedQuantity: number
) => {
    const { t } = useTranslation();
    const validatedFormatData = getValidatedFormats();
    return (files: File[]) => {
        const uploadFileList = [];
        let overallSize = 0;
        if (alreadyAttachedQuantity + files.length > 10) {
            // @ts-ignore
            swal({
                text: Errors.COUNT,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }
        if (files.length > 10) {
            // @ts-ignore
            swal({
                text: Errors.COUNT,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }

        for (let i = 0; i < files.length; i++) {
            const { extension } = getNameExtension(files[i].name);
            if (!validatedFormatData.includes(extension.toLowerCase())) {
                // @ts-ignore
                swal({
                    text: Errors.FORMAT,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('button.got_it.text'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return;
            }

            const checkValidate = isNotValidateSize(files[i].size, 500);

            if (checkValidate) {
                // @ts-ignore
                swal({
                    text: Errors.SIZE,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('button.got_it.text'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return;
            }
            uploadFileList.push(files[i]);

            overallSize += files[i].size;
        }

        const isOverallSize = isNotValidateSize(overallSize);

        if (isOverallSize) {
            // @ts-ignore
            swal({
                text: Errors.SIZE,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }
        onAddFile(uploadFileList);
    };
};
